import { render, staticRenderFns } from "./RfvSegmentsDetailsTable.vue?vue&type=template&id=25318d0c&scoped=true"
import script from "./RfvSegmentsDetailsTable.vue?vue&type=script&lang=js"
export * from "./RfvSegmentsDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./RfvSegmentsDetailsTable.vue?vue&type=style&index=0&id=25318d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25318d0c",
  null
  
)

export default component.exports